import { createActionGroup, props } from '@ngrx/store';

export const SettingsActions = createActionGroup({
  source: 'Settings',
  events: {
    'Set Language': props<{ value: string }>(),
    'Set Language Success': props<{ language: string }>(),
    'Set Notifications': props<{ value: boolean }>(),
    'Set Font Size': props<{ value: string }>(),
    'Set Transcript': props<{ value: string }>(),
  },
});
